import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import DataTableHelper from "../../../helpers/tables/DataTableHelper"
import Columns from './Columns'
import AddUpdModal from './AddUpdModal'
import { resourcesGeofence,activeBranch,duplicateBranch } from '../../../helpers/backend_helper';
import {DestroyAlertHelper,Alert,ToastHelper} from '../../../helpers/alerts/alertHelper';
import { getPolicyUser } from '../../../helpers/api_helper';
import {Container} from "reactstrap";
import { getStorageCompany,getStorageUser } from '../../../helpers/api_helper';
import ButtonHelper from '../../../helpers/ButtonHelper';

const Geofences = () => {
    const policy = getPolicyUser();
    const authUser = getStorageUser();
    const company = getStorageCompany();
    const [pending, setPending] = useState(false);
    const [modal, setModal] = useState({show:false,update:false});
    const [dataPag, setDataPag] = useState({total:0});
    const [filters,setFilters] = useState({page:1,perPage:20,search:'',orderBy:'id',order:'asc',companySession:company.id});
    const [items, setItems] = useState([]);
    const [itemBase, setItemBase] = useState({
        id: null,
        name: '',
        time_before: 5,
        time_after: 5,
        company_id:company.id,
        route_id:authUser.route_id,
        alias:'',
        numero: null,
        tipo: 'geocerca',
    });
    const [item, setItem] = useState(itemBase);
    const dispatch = useDispatch()
    useEffect(() => {
        //ToastHelper('mensaje','error')
        let params={params:filters}
        setPending(true)
        resourcesGeofence('get',params).then(response => {
            setItems(response.data)
            setDataPag(response.meta)
            //console.log(response)
            setPending(false)
        }
        )
    }, [filters])

    const addUpd = (row=false) => {
        setItem(row.id ? row:itemBase)
        setModal({...modal,show:true, update: (row.id ? true:false)})
    }

    const destroy = (id) => {
        DestroyAlertHelper(async confirmed => {
            if (!confirmed) { return; }
            resourcesGeofence('del',id,id).then(response => {
                Alert(response.message,response.status)
                if (response.status) {
                    setItems(
                        items.filter(i => i.id != id)
                    );
                }           
            })
        });
    }
    const active= (row) => {
        activeBranch(row).then(response => {
            console.log(response)
            if (response.status) {
                console.log(response.branch)
                let newItem=response.branch;
                let array = items.map(item => item.id !== newItem.id ? item : newItem);
                setItems(array);
            }
        })
    }
    const columns = Columns(addUpd,destroy,active,items,setItems,duplicateBranch,authUser);
	document.title = "Geocercas | Sistema de logística";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="col-12">
                        <DataTableHelper tittle="Geocercas" columns={columns} items={items} filterInp={false} pending={pending} config={dataPag} filters={filters} setFilters={setFilters}>
                            
                            <div className="mb-3">
                                <ButtonHelper 
                                    addButon={policy.branch_geo.create ? true:false}
                                    actionAddButon={policy.branch_geo.create ? addUpd:false}
                                />
                            </div>
                        </DataTableHelper>
                    </div>
                </Container>
                {modal.show &&
                    <AddUpdModal 
                        modal={modal}
                        setModal={setModal}
                        items={items}
                        setItems={setItems}
                        item={item}
                        setItem={setItem}
                        authUser={authUser}
                    />
                }
            </div>
        </React.Fragment>
    );
};

export default Geofences ;